export class User {
  constructor(data) {
    this.id = data.id;
    this.firstName = data.first_name;
    this.lastName = data.last_name;
    this.email = data.email;
    this.idNumber = data.id_number;
    this.role = data.role;
    this.moodleId = data.moodle_id;
    this.synced = !!data.moodle_id;
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`;
  }

  get isTeacher() {
    return this.role === 'Profesor';
  }

  get isStudent() {
    return this.role === 'Estudiante';
  }
}